// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2048":"868fe3ff","2729":"efe88785","3483":"e28ad47c","3593":"d3b8fd9c"}[chunkId] + ".chunk.css";
};